export default __webpack_public_path__ + "static/media/brakekit-small-blue.b96962cd.webp";